import { lazy } from "react";
import i18n from "i18next";
import type { PuzzleTypeModule } from "../types";
import type { NorinoriPresence } from "./Player";
import { registerNorinoriTranslations } from "./i18n";
import { localFeedback } from "./localCheck";
import { emptyDefinition, emptyProgress, migrateProgress, serializeSubmission } from "./progress";
import { emptySolution } from "./solution";
import type {
  NorinoriDefinition,
  NorinoriProgress,
  NorinoriSolution,
  NorinoriSubmission,
} from "./types";

registerNorinoriTranslations(i18n);

export const norinoriModule: PuzzleTypeModule<
  NorinoriDefinition,
  NorinoriSubmission,
  NorinoriProgress,
  NorinoriSolution,
  NorinoriPresence
> = {
  key: "norinori",
  Player: lazy(() => import("./Player")),
  Editor: lazy(() => import("./Editor")),
  SolutionEditor: lazy(() => import("./SolutionEditor")),
  PrintView: lazy(() => import("./PrintView")),
  emptyDefinition,
  emptyProgress,
  migrateProgress,
  serializeSubmission,
  emptySolution,
  localFeedback,
};
